import { render, staticRenderFns } from "./Logros.vue?vue&type=template&id=7638adac&scoped=true"
import script from "./Logros.vue?vue&type=script&lang=js"
export * from "./Logros.vue?vue&type=script&lang=js"
import style0 from "./Logros.vue?vue&type=style&index=0&id=7638adac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7638adac",
  null
  
)

export default component.exports